var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMDirectorioEmpleados(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 66 66",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#2eccb6;}.cls-2{fill:#329be6;}.cls-3{fill:#0b5c96;}.cls-4{fill:#fff;}.cls-5{fill:none;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_3",
    "data-name": "Layer 3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "m_directorio_empleados"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M32.72,65.72a.4.4,0,0,0,.56,0l8.31-8.31H24.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M33.28.28a.4.4,0,0,0-.56,0L24.41,8.59H41.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M15.52,39.25H13.34a.4.4,0,0,1-.4-.4v-1.7a.4.4,0,0,1,.4-.4h2.18v-7.5H13.34a.4.4,0,0,1-.4-.4v-1.7a.4.4,0,0,1,.4-.4h2.18v-7.5H13.75L.28,32.72a.4.4,0,0,0,0,.56L13.75,46.75h1.77Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "49.36 49.64 52.5 46.5 49.36 46.5 49.36 49.64"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M65.72,32.72l-8.78-8.78V29.6a.4.4,0,0,1-.4.4h-2.1V44.56L65.72,33.28A.4.4,0,0,0,65.72,32.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M46.86,54.91H44.09l-2.5,2.5H49a.4.4,0,0,0,.4-.4V49.64l-2.5,2.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M54,46.5a.4.4,0,0,0,.4-.4V44.56L52.5,46.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M18,11.09h3.89l2.5-2.5H15.92a.4.4,0,0,0-.4.4v7.76H13.34a.4.4,0,0,0-.4.4v1.7a.4.4,0,0,0,.4.4h.41L18,15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M46.86,11.09v2.77l2.5,2.5V13.5h5.08v7.94l2.5,2.5V11.4a.4.4,0,0,0-.4-.4H49.36V9a.4.4,0,0,0-.4-.4H41.59l2.5,2.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M18,54.91V51l-4.27-4.27h-.41a.4.4,0,0,0-.4.4v1.7a.4.4,0,0,0,.4.4h2.18V57a.4.4,0,0,0,.4.4h8.49l-2.5-2.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M56.54,30a.4.4,0,0,0,.4-.4V23.94l-2.5-2.5V27.5H49.36V16.36l-2.5-2.5V29.69c0,.1,0,.21,0,.31h0V52.14l2.5-2.5V46.5H52.5l1.94-1.94V30Zm-4.6,14H49.36V30h2.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M18,49.25h1.52a.4.4,0,0,0,.4-.4v-1.7a.4.4,0,0,0-.4-.4H18v-7.5h1.52a.4.4,0,0,0,.4-.4v-1.7a.4.4,0,0,0-.4-.4H18v-7.5h1.52a.4.4,0,0,0,.4-.4v-1.7a.4.4,0,0,0-.4-.4H18v-7.5h1.52a.4.4,0,0,0,.4-.4v-1.7a.4.4,0,0,0-.4-.4H18V15l-4.27,4.27h1.77v7.5H13.34a.4.4,0,0,0-.4.4v1.7a.4.4,0,0,0,.4.4h2.18v7.5H13.34a.4.4,0,0,0-.4.4v1.7a.4.4,0,0,0,.4.4h2.18v7.5H13.75L18,51Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "44.09 11.09 41.59 8.59 24.41 8.59 21.91 11.09 44.09 11.09"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "21.91 54.91 24.41 57.41 41.59 57.41 44.09 54.91 21.91 54.91"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M33,32.37a3.44,3.44,0,1,0-3.43-3.44A3.44,3.44,0,0,0,33,32.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M46.86,11.09H18v5.66h1.52a.4.4,0,0,1,.4.4v1.7a.4.4,0,0,1-.4.4H18v7.5h1.52a.4.4,0,0,1,.4.4v1.7a.4.4,0,0,1-.4.4H18v7.5h1.52a.4.4,0,0,1,.4.4v1.7a.4.4,0,0,1-.4.4H18v7.5h1.52a.4.4,0,0,1,.4.4v1.7a.4.4,0,0,1-.4.4H18v5.66H46.86V30h0c0-.1,0-.21,0-.31ZM33,23A5.94,5.94,0,1,1,27,28.93,5.94,5.94,0,0,1,33,23Zm8.41,17.34-.86,1.47a.4.4,0,0,1-.55.13,13.83,13.83,0,0,0-14,0,.38.38,0,0,1-.53-.12l-.94-1.42a.4.4,0,0,1,.13-.57,16.43,16.43,0,0,1,16.57,0A.4.4,0,0,1,41.37,40.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M33,34.87A5.94,5.94,0,1,0,27,28.93,5.94,5.94,0,0,0,33,34.87Zm0-9.37a3.44,3.44,0,1,1-3.43,3.43A3.44,3.44,0,0,1,33,25.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M41.23,39.79a16.43,16.43,0,0,0-16.57,0,.4.4,0,0,0-.13.57l.94,1.42a.38.38,0,0,0,.53.12,13.83,13.83,0,0,1,14,0,.4.4,0,0,0,.55-.13l.86-1.47A.4.4,0,0,0,41.23,39.79Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 49.36,
    y: 30,
    width: 2.58,
    height: 14
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 49.36,
    y: 13.5,
    width: 5.08,
    height: 14
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    width: 66,
    height: 66
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMDirectorioEmpleados);
export default __webpack_public_path__ + "static/media/m_directorio_empleados.deb61a936adaff983cf4c06b7dd976da.svg";
export { ForwardRef as ReactComponent };